import { Component, Input } from '@angular/core';
import { RoleMatrix } from 'src/helpers';

@Component({
    selector: 'app-breadcrumb-comp-work-order-categories-add-edit',
    templateUrl: './breadcrumb.comp.work.order.category.add.edit.component.html'
})

export class BreadcrumbCompanyWorkOrderCategoriesAddEditComponent {
    @Input() companyId: number;
    @Input() label:string;
    
    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
